// @ts-nocheck
/** MI DOMINO - net/table. */
import { PREMIOS } from '../data/config';
import { L, animateHand, fireworks, hideZones, layoutBoard, netTileClick, nudgeTile, scatterTile, showModal, showWashHands, showZones, turnCue } from '../game/engine';
import { buzzer, celebration, clack, explosion, shuffleSound, siren, womp } from '../game/sounds';
import { tileEl } from '../game/tile';
import { BACKS_BY_REL, NAME_BY_REL, REL, SEAT_EL_BY_REL, VID_BY_REL, netSides } from './online';
import { API_TOKEN, MATCH_LOG, NET, SETTINGS, STATS, myStream, setDragTile, setMATCH_LOG, socket } from '../state';
import { mediaOn, mediaSyncLocal, setMeshFallback, startMedia, stopMedia } from './media';
import { banner } from '../ui/banner';
import { addChat, hideLobby, log } from '../ui/feed';
import { LANG, t } from '../ui/i18n';
import { addXP, saveStats } from '../identity/profile';
import { API_BASE } from './base';
import { earnCoins, saveMatchLog } from '../game/engine';
import { restoreLobby } from '../admin/portal';
import { RANKS, rankFor } from '../identity/ranks';
import { cname } from '../data/catalog';

/** 👤 Tap a seat → who is that? Bot, guest, or a signed-in player's public card
 *  (nick, country, rank, record). The data rides along with every state. */
export function showPlayerCard(seat) {
  const s = NET.snap;
  const p = s && s.players && s.players[seat];
  if (!p) return;
  const rel = REL(seat);
  const who = rel === 0 ? L('Tú', 'You') : rel === 2 ? L('Tu socio', 'Your partner') : L('Rival', 'Rival');
  let body;
  if (p.isAI) {
    body = `<p style="font-size:44px;margin:4px 0">🤖</p><p>${L('Máquina de la casa — juega mientras no llega un compay.', 'House bot — plays until a compay shows up.')}</p>`;
  } else if (p.guest) {
    body = `<p style="font-size:44px;margin:4px 0">👤</p><p>${L('Invitado — juega sin cuenta, sin rango ni historial.', 'Guest — playing without an account, no rank or record.')}</p>`;
  } else {
    const ri = rankFor(p.xp || 0);
    const R = RANKS[ri];
    const games = p.games || 0, wins = p.wins || 0;
    const rate = games ? Math.round(wins / games * 100) : 0;
    const flag = p.country || '🌎';
    body = `<p style="font-size:44px;margin:4px 0">${flag}</p>
      <p><b style="font-size:18px">${p.apodo || p.name}</b></p>
      ${cname(flag) !== flag ? `<p style="opacity:.8">${cname(flag)}</p>` : ''}
      <p style="margin-top:8px"><b>${R[0]} ${LANG === 'en' ? R[2] : R[1]}</b> <small style="opacity:.6">(${L('rango', 'rank')} ${ri + 1}/10 · ${p.xp || 0} XP)</small></p>
      <div style="display:flex;gap:14px;justify-content:center;margin-top:10px">
        <div><div style="font-size:22px;font-weight:800;color:var(--gold)">${wins}/${games}</div><small style="opacity:.7">${L('partidas ganadas', 'matches won')}</small></div>
        <div><div style="font-size:22px;font-weight:800;color:var(--gold)">${rate}%</div><small style="opacity:.7">${L('victorias', 'win rate')}</small></div>
        <div><div style="font-size:22px;font-weight:800;color:var(--gold)">${p.points || 0}</div><small style="opacity:.7">${L('puntos online', 'online points')}</small></div>
      </div>`;
  }
  showModal(`${who} · ${p.name}`, body, 'OK', () => {}, true);
}

// ¡A MENEAR FICHA! online — the shake ritual, canon-faithful. The team that LOST
// the last hand shakes: if that's YOUR team you stir with the mouse and press
// "¡YA!" when done (the server holds the deal until then); otherwise you watch
// the rival's hands auto-stir. Tiles are dealt server-side — this is ceremony.
let washTimer = null;         // auto-stir interval (rival shakes)
let washMoveHandler = null;   // felt mousemove listener (I shake)
let washDoneSent = false;
let washing = false;
let wasMyTurnNet = false;      // edge-detect your turn online (for the turn cue)
let lastRematch = null;        // 🔁 latest vote tally (may arrive before the modal is drawn)

// ⏱ turn clock — the server says who is on turn and until when; we draw the
// countdown on that seat (and warn you when YOUR clock is about to run out:
// the table then plays for you, the bot's choice).
let turnClock = { seat: -1, endsAt: 0 };
let turnTick = null;
let warned = false;
function ttEl(seat) {
  const host = document.getElementById(SEAT_EL_BY_REL[REL(seat)]);
  if (!host) return null;
  let el = host.querySelector('.tt');
  if (!el) { el = document.createElement('div'); el.className = 'tt'; host.appendChild(el); }
  return el;
}
export function startTurnClock(t) {
  turnClock = { seat: t.seat, endsAt: t.endsAt || 0 };
  warned = false;
  for (const el of document.querySelectorAll('.seat .tt')) { el.textContent = ''; el.classList.remove('urgent'); }
  if (turnTick) { clearInterval(turnTick); turnTick = null; }
  if (!turnClock.endsAt) return;                       // a bot is thinking: no clock
  const draw = () => {
    const left = Math.max(0, Math.ceil((turnClock.endsAt - Date.now()) / 1000));
    const el = ttEl(turnClock.seat);
    if (!el) return;
    el.textContent = `⏱ ${left}s`;
    const mine = turnClock.seat === NET.mySeat;
    el.classList.toggle('urgent', left <= 5);
    if (mine && left <= 5 && !warned) { warned = true; try { buzzer(); } catch (e) {} banner(L('⏱ ¡Te quedan 5 segundos!', '⏱ 5 seconds left!')); }
    if (left <= 0) { clearInterval(turnTick); turnTick = null; }
  };
  draw();
  turnTick = setInterval(draw, 250);
}
export function stopTurnClock() {
  if (turnTick) { clearInterval(turnTick); turnTick = null; }
  for (const el of document.querySelectorAll('.seat .tt')) el.textContent = '';
}

export function onlineWash(info) {
  washing = true;
  washDoneSent = false;
  wasMyTurnNet = false;        // new hand — cue fires fresh when play reaches you
  // the shake happens BEFORE the first state, so the wait-room overlay is still
  // up and would block the felt — drop it now so the mouse can reach the shake.
  hideLobby();
  document.getElementById('modal-bg').classList.remove('show'); // make way for the shake

  const board = document.getElementById('board');
  board.innerHTML = '';
  const W = Math.max((board.clientWidth || 700) - 60, 100);
  const H = Math.max((board.clientHeight || 350) - 40, 80);
  for (let i = 0; i < 14; i++) {
    const el = document.createElement('div');
    el.className = 'wash-tile';
    scatterTile(el, W, H);
    board.appendChild(el);
  }
  showWashHands(true);

  const iShake = (NET.mySeat % 2) === info.loserTeam;
  log(`${L('Mano', 'Hand')} ${info.handNum}${info.prize ? L(' · CON PREMIOS', ' · WITH PRIZES') : ''} — ${iShake
    ? L('¡les toca menear! Mueve el mouse sobre la mesa 🖐️', 'your team shuffles! Move the mouse over the table 🖐️')
    : L('el equipo rival menea las fichas… 🌀', 'the rival team shuffles the dominos… 🌀')}`, true);
  if (iShake) startInteractiveWash(); else startAutoWash();
}

/** Rival team shakes — their giant hands circle on their own. */
function startAutoWash() {
  banner(L('¡A MENEAR FICHA! 🙌', 'SHUFFLE TIME! 🙌'));
  const board = document.getElementById('board');
  const W = Math.max((board.clientWidth || 700) - 60, 100);
  const H = Math.max((board.clientHeight || 350) - 40, 80);
  const hl = document.getElementById('wash-hand-l');
  const hr = document.getElementById('wash-hand-r');
  hl.style.transition = hr.style.transition = 'left .42s ease-in-out, top .42s ease-in-out';
  let n = 0;
  if (washTimer) clearInterval(washTimer);
  washTimer = setInterval(() => {
    const px = W / 2 + Math.cos(n * 1.3) * 130;
    const py = H / 2 - 40 + Math.sin(n * 1.3) * 65;
    for (const el of board.querySelectorAll('.wash-tile')) {
      const ex = (parseFloat(el.style.left) || 0) + 23, ey = (parseFloat(el.style.top) || 0) + 12;
      const dx = ex - px, dy = ey - py, dist = Math.hypot(dx, dy);
      if (dist < 190) nudgeTile(el, dx / (dist || 1), dy / (dist || 1), W, H);
    }
    hl.style.left = (px - 115) + 'px'; hl.style.top = py + 'px'; hl.style.transform = 'rotate(-7deg)';
    hr.style.left = (px + 16) + 'px'; hr.style.top = py + 'px'; hr.style.transform = 'rotate(7deg)';
    shuffleSound();
    n++;
  }, 450);
}

/** My team lost — I shake: giant hands glued to my mouse push the fichas; I press
 *  "¡YA!" (or enough stirring) to finish, which tells the server to deal. */
function startInteractiveWash() {
  banner(L('¡A MENEAR FICHA! Mueve el mouse 🖐️', 'SHUFFLE TIME! Move the mouse 🖐️'));
  let moves = 0;
  const felt = document.getElementById('felt');
  const board = document.getElementById('board');
  const hl = document.getElementById('wash-hand-l');
  const hr = document.getElementById('wash-hand-r');
  let lastShf = 0;
  washMoveHandler = ev => {
    const fr = felt.getBoundingClientRect();
    const x = ev.clientX - fr.left, y = ev.clientY - fr.top;
    hl.style.transition = hr.style.transition = 'none';
    const w = Math.sin(Date.now() / 130) * 5;
    hl.style.left = (x - 115) + 'px'; hl.style.top = (y - 48) + 'px'; hl.style.transform = `rotate(${-7 + w}deg)`;
    hr.style.left = (x + 16) + 'px'; hr.style.top = (y - 48) + 'px'; hr.style.transform = `rotate(${7 - w}deg)`;
    const br = board.getBoundingClientRect();
    const mx = ev.clientX - br.left, my = ev.clientY - br.top;
    const W = Math.max(br.width - 60, 100), H = Math.max(br.height - 40, 80);
    let pushed = 0;
    for (const el of board.querySelectorAll('.wash-tile')) {
      const ex = (parseFloat(el.style.left) || 0) + 23, ey = (parseFloat(el.style.top) || 0) + 12;
      const dx = ex - mx, dy = ey - my, dist = Math.hypot(dx, dy);
      if (dist < 135) { nudgeTile(el, dx / (dist || 1), dy / (dist || 1), W, H); pushed++; }
    }
    if (pushed) {
      moves += pushed;
      const now = Date.now();
      if (now - lastShf > 140) { shuffleSound(); lastShf = now; }
      if (moves >= 40) sendWashDone(); // stirred enough — you can stop
    }
  };
  felt.addEventListener('mousemove', washMoveHandler);

  // canon: YOU decide when to stop — an explicit "ya, meneadas" button too
  const b = document.createElement('button');
  b.id = 'btn-deal-net';
  b.className = 'btn gold';
  b.textContent = L('⏹ ¡PARAR Y AGARRAR! ✋', '⏹ STOP & GRAB! ✋');
  b.style.cssText = 'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:20;width:auto;padding:14px 22px;';
  b.onclick = sendWashDone;
  felt.appendChild(b);
}

function sendWashDone() {
  if (washDoneSent) return;
  washDoneSent = true;
  removeWashInput();
  banner(L('¡YA ESTÁN MENEADAS! ✋', 'ALL SHUFFLED! ✋'));
  socket.emit('washDone'); // server reveals the deal → 'state' ends the ceremony
}

function removeWashInput() {
  if (washMoveHandler) {
    document.getElementById('felt').removeEventListener('mousemove', washMoveHandler);
    washMoveHandler = null;
  }
  const b = document.getElementById('btn-deal-net');
  if (b) b.remove();
}

export function endOnlineWash() {
  if (!washing) return;
  washing = false;
  if (washTimer) { clearInterval(washTimer); washTimer = null; }
  removeWashInput();
  showWashHands(false);
  const board = document.getElementById('board');
  if (board) for (const el of [...board.querySelectorAll('.wash-tile')]) el.remove();
}

// ¡AGARRA TUS 7! online — after the shake, you grab your 7 tiles one by one from
// a face-down pile (canon: nothing automatic). The deal is already server-fixed;
// each tap just reveals the next of YOUR tiles into the rack. When done we tell
// the server (grabbed) — play begins once every human has grabbed.
let pendingGrab = false;
let grabbingNow = false;
let grabAutoTimer = null;

export function onlineGrab(myHand) {
  grabbingNow = true;
  banner(L('¡AGARRA TUS 7! ✋', 'GRAB YOUR 7! ✋'));
  const board = document.getElementById('board');
  const hand = document.getElementById('hand');
  hand.innerHTML = ''; // you haven't grabbed yet — clear the auto-drawn hand
  board.innerHTML = '';
  const W = Math.max((board.clientWidth || 700) - 60, 100);
  const H = Math.max((board.clientHeight || 350) - 40, 80);
  const pile = Math.min(Math.max(myHand.length + 4, 7), 14);
  for (let i = 0; i < pile; i++) {
    const el = document.createElement('div');
    el.className = 'wash-tile'; // face-down ficha
    scatterTile(el, W, H);
    el.onclick = () => grabOne(el);
    board.appendChild(el);
  }
  let grabbed = 0;
  function grabOne(el) {
    if (!grabbingNow || el._taken || grabbed >= myHand.length) return;
    el._taken = true; el.dataset.taken = '1';
    const tile = myHand[grabbed++];
    clack();
    // fade + shrink in place (don't move below the felt — that made #felt scroll)
    el.style.transition = 'transform .3s ease, opacity .3s ease';
    el.style.transform += ' scale(.2)';
    el.style.opacity = '0';
    setTimeout(() => el.remove(), 320);
    hand.appendChild(tileEl(tile, '', true)); // face-up into the rack (preview)
    if (grabbed >= myHand.length) finishGrab();
  }
  // safety: if the player dawdles, auto-grab the rest before the server cap trips
  if (grabAutoTimer) clearTimeout(grabAutoTimer);
  grabAutoTimer = setTimeout(function auto() {
    if (!grabbingNow) return;
    const free = [...board.querySelectorAll('.wash-tile')].find(e => !e._taken);
    if (free) grabOne(free);
    if (grabbingNow) grabAutoTimer = setTimeout(auto, 260);
  }, 8000);

  function finishGrab() {
    if (!grabbingNow) return;
    grabbingNow = false;
    if (grabAutoTimer) { clearTimeout(grabAutoTimer); grabAutoTimer = null; }
    for (const e of [...board.querySelectorAll('.wash-tile')]) e.remove();
    renderNet();              // rebuild the rack as a proper interactive hand
    socket.emit('grabbed');   // I'm ready → server starts play once all humans are
    banner(L('¡A JUGAR! 🎯', 'LET\'S PLAY! 🎯'));
  }
}

/** Abort an in-progress grab (e.g. play already started via the server cap). */
export function endOnlineGrab() {
  if (!grabbingNow) return;
  grabbingNow = false;
  if (grabAutoTimer) { clearTimeout(grabAutoTimer); grabAutoTimer = null; }
  const board = document.getElementById('board');
  if (board) for (const el of [...board.querySelectorAll('.wash-tile')]) el.remove();
}

/** Online play counts like solo play: hands and matches feed your stats, XP,
 *  PhilCoins, streak and match history (it used to feed only the 🌐 mission).
 *  Called once per handEnd, before the count ritual. */
function bookOnlineHand(p) {
  const myTeam = NET.mySeat % 2;
  const won = p.winnerTeam === myTeam;
  const text = [p.title, ...(p.lines || [])].join(' ');
  STATS.hands = (STATS.hands || 0) + 1;
  STATS.onlineHands = (STATS.onlineHands || 0) + 1;
  if (won) {
    STATS.handsWon = (STATS.handsWon || 0) + 1;
    const tranque = p.count && p.count.mode === 'tranque';
    if (tranque) { STATS.tranquesWon = (STATS.tranquesWon || 0) + 1; addXP(25, L('tranque ganado 🔒', 'tranque won 🔒')); }
    if (/CAPICÚ/.test(text)) { STATS.capicus = (STATS.capicus || 0) + 1; addXP(25, 'capicú 🎯'); }
    if (/CHUCHAZO/.test(text)) { STATS.chuchazos = (STATS.chuchazos || 0) + 1; addXP(40, 'chuchazo 💥'); }
    addXP(10, L('mano ganada', 'hand won'));
    earnCoins(25, L('mano ganada', 'hand won'));
  }
  if (p.matchOver) {
    const iWon = p.scores[myTeam] >= p.target;
    STATS.matches = (STATS.matches || 0) + 1;
    if (iWon) {
      STATS.matchesWon = (STATS.matchesWon || 0) + 1;
      STATS.streak = (STATS.streak || 0) + 1;
      STATS.bestStreak = Math.max(STATS.bestStreak || 0, STATS.streak);
      const margin = Math.max(p.scores[myTeam] - p.scores[1 - myTeam], 0);
      const base = 50 + Math.min(30, Math.round(margin / 10));
      const mult = STATS.streak >= 4 ? 1.5 : STATS.streak >= 2 ? 1.25 : 1;
      addXP(Math.round(base * mult), STATS.streak >= 2 ? L(`¡VICTORIA ONLINE! (racha 🔥x${STATS.streak})`, `ONLINE VICTORY! (streak 🔥x${STATS.streak})`) : L('¡VICTORIA ONLINE!', 'ONLINE VICTORY!'));
      earnCoins(150, L('¡PARTIDA GANADA! 🏆', 'MATCH WON! 🏆'));
    } else {
      STATS.streak = 0;
    }
    MATCH_LOG.unshift({ d: Date.now(), won: iWon, a: p.scores[myTeam], b: p.scores[1 - myTeam], online: true });
    setMATCH_LOG(MATCH_LOG.slice(0, 20));
    saveMatchLog();
  }
  saveStats();
}

/** 🔁 Revancha vote state (from the server) → the match-over modal. */
function renderRematch(v) {
  const box = document.getElementById('rematch-status');
  if (!box) return;
  const mine = NET.mySeat !== null && v.votes.includes(NET.mySeat);
  const btn = document.getElementById('btn-rematch');
  if (btn && mine) { btn.disabled = true; btn.textContent = `✅ ${t('rematchIn')}`; }
  box.textContent = v.waiting.length
    ? `🔁 ${v.names.join(', ')} ${L('quiere(n) revancha', 'want(s) a rematch')} · ${t('rematchWait')}: ${v.waiting.join(', ')} (${v.votes.length}/${v.need})`
    : L('¡Todos dentro! Barajando… 🔁', 'Everyone is in! Shuffling… 🔁');
}

/** The hand-result panel (score / match-over celebration). */
export function showResult(p) {
  const myTeam = NET.mySeat % 2;
  const body = p.lines.map(l => `<p>${l}</p>`).join('') +
    `<p style="margin-top:10px">${t('score')}: <b>${t('us')} ${p.scores[myTeam]} — ${p.scores[1 - myTeam]} ${t('them')}</b> (${t('matchTo').toLowerCase()} ${p.target})</p>`;
  if (p.matchOver) {
    const won = p.scores[myTeam] >= p.target;
    if (won) { celebration(); fireworks(); } else womp();
    // 🔁 the same table, same partners, right away — or back to the lobby
    const rematchHTML = `<button class="btn gold" id="btn-rematch" style="width:100%;margin-top:12px">${t('rematch')}</button>
      <p id="rematch-status" style="font-size:12px;opacity:.8;min-height:16px;margin-top:6px"></p>`;
    showModal(won ? L('🏆🔥 ¡GANAMOS LA PARTIDA!', '🏆🔥 WE WON THE MATCH!') : L('😤 Perdimos la partida', '😤 We lost the match'), body + rematchHTML,
      t('backLobby'), () => location.reload());
    const rb = document.getElementById('btn-rematch');
    if (rb) rb.onclick = () => {
      rb.disabled = true;
      rb.textContent = L('⏳ Pidiendo revancha…', '⏳ Asking for a rematch…');
      socket.emit('rematch', res => { if (!res || !res.ok) { rb.disabled = false; rb.textContent = t('rematch'); } });
    };
    if (lastRematch) renderRematch(lastRematch);
  } else {
    showModal(p.title, body + `<p style="opacity:.7">${L('La próxima mano empieza cuando todos cuenten…', 'The next hand starts once everyone has counted…')}</p>`,
      'OK', () => {});
  }
}

// ¡A CONTAR! online — flip the losers' fichas and tap each to tally the points
// (canon: nothing automatic). The score is already server-authoritative; this is
// the verification ritual. When done we tell the server (counted) — the next
// hand deals once every human has tallied.
export function showNetCount(p) {
  const cd = p.count;
  const myTeam = NET.mySeat % 2;
  let idx = 0;
  let html = `<p>${L('Voltea y cuenta las fichas — tócalas una por una 👆', 'Flip and count the dominos — tap them one by one 👆')}</p>`;
  for (const g of cd.groups) {
    html += `<p style="margin-top:8px"><b>${g.name}</b> · ${g.team === myTeam ? t('us') : t('them')}</p><div>`;
    for (const t of g.tiles) {
      html += `<span class="count-tile" data-i="${idx++}" data-p="${t[0] + t[1]}" data-team="${g.team}">${t[0]}·${t[1]}</span>`;
    }
    html += '</div>';
  }
  html += L('<p style="margin-top:10px;font-size:17px">Contado: <b id="count-total">0</b> puntos<span id="count-teams" style="opacity:.8"></span></p>',
            '<p style="margin-top:10px;font-size:17px">Counted: <b id="count-total">0</b> points<span id="count-teams" style="opacity:.8"></span></p>');
  html += `<button class="btn" id="count-rapid" style="width:100%;margin-top:10px">${L('Contar todas ⚡', 'Count them all ⚡')}</button>
    <p style="font-size:11px;opacity:.6;margin-top:4px">${L('(barra espaciadora en la compu)', '(spacebar on the computer)')}</p>`;
  document.getElementById('modal-title').innerHTML = cd.mode === 'tranque' ? L('¡Tranque! — A contar', 'Tranque! — Time to count') : p.title;
  document.getElementById('modal-body').innerHTML = html;
  const btn = document.getElementById('modal-btn');
  btn.textContent = L('Cuenta primero…', 'Count first…');
  btn.disabled = true; btn.style.opacity = '.5';
  document.getElementById('modal-bg').classList.add('show');

  const tiles = [...document.querySelectorAll('.count-tile')];
  let total = 0; const teamTot = [0, 0]; let left = tiles.length;
  const done = () => { btn.disabled = false; btn.style.opacity = '1'; btn.textContent = t('apply'); };
  for (const el of tiles) {
    el.onclick = () => {
      if (el.classList.contains('counted')) return;
      el.classList.add('counted');
      total += +el.dataset.p; teamTot[+el.dataset.team] += +el.dataset.p; left--;
      clack();
      document.getElementById('count-total').textContent = total;
      document.getElementById('count-teams').textContent = ` · ${t('us')} ${teamTot[myTeam]} — ${teamTot[1 - myTeam]} ${t('them')}`;
      if (left === 0) done();
    };
  }
  if (left === 0) done();

  // rapid: one button (📱) or spacebar (💻) taps the rest
  const uncounted = () => tiles.find(el => !el.classList.contains('counted'));
  const rapid = document.getElementById('count-rapid');
  if (rapid) rapid.onclick = () => {
    rapid.disabled = true; rapid.style.opacity = '.5';
    const iv = setInterval(() => { const el = uncounted(); if (el && el.onclick) el.onclick(); else clearInterval(iv); }, 90);
  };
  try {
    if (window._netCountKey) window.removeEventListener('keydown', window._netCountKey);
    window._netCountKey = ev => {
      if (ev.code !== 'Space' && ev.key !== ' ') return;
      ev.preventDefault();
      const el = uncounted(); if (el && el.onclick) el.onclick();
    };
    window.addEventListener('keydown', window._netCountKey);
  } catch (e) {}

  btn.onclick = () => {
    if (btn.disabled) return;
    try { if (window._netCountKey) { window.removeEventListener('keydown', window._netCountKey); window._netCountKey = null; } } catch (e) {}
    document.getElementById('modal-bg').classList.remove('show');
    socket.emit('counted'); // I've tallied → server deals the next hand once all humans have
    showResult(p);
  };
}

export function renderNet() {
  const s = NET.snap;
  if (!s) return;
  NET.mySeat = s.mySeat;
  const myTeam = s.mySeat % 2;
  document.getElementById('score0').textContent = s.scores[myTeam];
  document.getElementById('score1').textContent = s.scores[1 - myTeam];
  document.getElementById('target-label').textContent =
    `${t('matchTo')} ${s.target} · ${s.prize ? t('conPremios') : t('casual')} · ONLINE`;

  for (let seat = 0; seat < 4; seat++) {
    const rel = REL(seat);
    const el = document.getElementById(NAME_BY_REL[rel]);
    if (el) el.textContent = rel === 0 ? t('you') + ' · ' + s.names[seat]
      : rel === 2 ? s.names[seat] + L(' (socio)', ' (partner)') : s.names[seat];
    // 👤 tap a seat (avatar or name) → player card
    const host = document.getElementById(SEAT_EL_BY_REL[rel]);
    if (host && !host.classList.contains('peek')) {
      host.classList.add('peek');
      for (const sel of ['.cam', '.pname']) {
        const z = host.querySelector(sel);
        if (z) z.addEventListener('click', (ev) => { if (ev.target.closest('.cam-controls')) return; if (NET.active && NET.snap) showPlayerCard((NET.mySeat + rel) % 4); });
      }
    }
  }

  layoutBoard(document.getElementById('board'), s.board, s.justPlayed ? s.lastIdx : -1);
  if (s.justPlayed) {
    clack();
    const rel = REL(s.placedBy);
    if (rel !== 0) {
      const kids = document.getElementById('board').children;
      const target = kids[s.lastIdx] ? kids[s.lastIdx].getBoundingClientRect() : null;
      animateHand(rel, target); // reach to the placed tile, not the center
    }
  }

  const hand = document.getElementById('hand');
  hand.innerHTML = '';
  const myTurn = s.turn === s.mySeat;
  // "your turn" cue online too — chime + rack glow on the transition into your turn
  if (myTurn && !wasMyTurnNet) turnCue();
  wasMyTurnNet = myTurn;
  // ¡NO VOY! — shown on your turn online, declared by you (like offline)
  const pb = document.getElementById('btn-paso');
  if (pb) pb.style.display = myTurn ? 'inline-block' : 'none';
  for (const t of s.myHand) {
    const ok = netSides(t).length > 0;
    const el = tileEl(t, (SETTINGS.hints && myTurn) ? (ok ? 'playable' : 'dead') : '', true);
    el.onclick = () => netTileClick(t);
    if (myTurn && ok) {
      el.draggable = true;
      el.addEventListener('dragstart', ev => {
        setDragTile(t); showZones(t);
        ev.dataTransfer.setData('text/plain', 'tile');
      });
      el.addEventListener('dragend', hideZones);
    }
    hand.appendChild(el);
  }

  for (let seat = 0; seat < 4; seat++) {
    const rel = REL(seat);
    if (rel !== 0) {
      const backs = document.getElementById(BACKS_BY_REL[rel]);
      backs.innerHTML = '';
      for (let i = 0; i < s.counts[seat]; i++) {
        const b = document.createElement('div'); b.className = 'back'; backs.appendChild(b);
      }
    }
    document.getElementById(SEAT_EL_BY_REL[rel]).classList.toggle('active', s.turn === seat);
  }
}

/* Video routing: STUN by default; the server adds a TURN relay when configured,
 *  so players on different networks (or behind strict firewalls) still connect. */
let ICE_SERVERS: any[] = [{ urls: 'stun:stun.l.google.com:19302' }];
fetch(API_BASE + '/api/ice').then(r => r.json()).then(d => { if (d && d.iceServers) ICE_SERVERS = d.iceServers; }).catch(() => { /* keep STUN */ });

/** iPhone and Android block sound and video until the user taps: try now, and again on the first tap. */
function playRemote(v: HTMLVideoElement): void {
  try { const r: any = v.play(); if (r && r.catch) r.catch(() => { /* waits for a tap */ }); } catch (e) { /* ignore */ }
}
let unlockBound = false;
function bindUnlock(): void {
  if (unlockBound) return;
  unlockBound = true;
  const unlock = () => {
    document.querySelectorAll('video').forEach((v) => playRemote(v as HTMLVideoElement));
    try {
      const AC: any = (window as any).AudioContext || (window as any).webkitAudioContext;
      if (AC) { const ctx = new AC(); if (ctx.resume) ctx.resume(); }
    } catch (e) { /* ignore */ }
  };
  ['touchend', 'click', 'keydown'].forEach((ev) => document.addEventListener(ev, unlock, { passive: true }));
}

// Mesh fallback: used when LiveKit is off or cannot connect (receives the peer list from the server).
setMeshFallback((peers) => { for (const o of peers) makePeer(o.socketId, o.seat, true); });

export function makePeer(id, seat, initiator) {
  if (NET.peers[id]) return NET.peers[id];
  const pc = new RTCPeerConnection({ iceServers: ICE_SERVERS });
  const peer = (NET.peers[id] = { pc, seat });
  pc.onicecandidate = e => {
    if (e.candidate) socket.emit('webrtc', { to: id, data: { candidate: e.candidate } });
  };
  pc.ontrack = e => {
    const vid = document.getElementById(VID_BY_REL[REL(seat)] || 'vid1') as HTMLVideoElement | null;
    if (!vid) return;
    // one MediaStream per seat: audio and video arrive as separate tracks
    const ms: MediaStream = (vid.srcObject instanceof MediaStream) ? vid.srcObject : new MediaStream();
    if (!ms.getTracks().includes(e.track)) ms.addTrack(e.track);
    vid.srcObject = ms;
    vid.playsInline = true;
    vid.style.display = 'block';
    playRemote(vid);
    e.track.onunmute = () => playRemote(vid);
    bindUnlock();
  };
  pc.onnegotiationneeded = async () => {
    try {
      const off = await pc.createOffer();
      await pc.setLocalDescription(off);
      socket.emit('webrtc', { to: id, data: { sdp: pc.localDescription } });
    } catch (e) {}
  };
  if (myStream) for (const tr of myStream.getTracks()) pc.addTrack(tr, myStream);
  else if (initiator) pc.createDataChannel('x'); // kick off connection even without cam
  return peer;
}

export function netAttachTracks() {
  mediaSyncLocal();
  if (!myStream) return;
  for (const id in NET.peers) {
    const pc = NET.peers[id].pc;
    for (const tr of myStream.getTracks()) {
      if (!pc.getSenders().some(sn => sn.track === tr)) pc.addTrack(tr, myStream);
    }
  }
}

/** The server speaks Spanish (its messages are the source of truth for every
 *  table). For an English player we translate the known server sentences on
 *  arrival — logs, banners and the hand-end sheet. Player names are captured
 *  by the patterns and kept. Unknown text passes through untouched. */
const NET_ES_EN = [
  [/^¡Empieza la partida a (\d+)!$/, 'Match to $1 starts!'],
  [/^¡REVANCHA! 🔁$/, 'REMATCH! 🔁'],
  [/^⏱ (.+) se durmió — la mesa jugó por él$/, '⏱ $1 dozed off — the table played for them'],
  [/^(.+) se reconectó$/, '$1 reconnected'],
  [/^(.+) se desconectó — máquina lo reemplaza \(puede reconectar\)$/, '$1 disconnected — a bot fills in (they can reconnect)'],
  [/^🏆 PREMIO mano (\d+): \+(\d+)$/, '🏆 HAND PRIZE $1: +$2'],
  [/^(.+) tiene el doble seis y sale\.$/, '$1 has the double six and leads.'],
  [/^(.+) sale esta mano\.$/, '$1 leads this hand.'],
  [/^(.+): ¡NO VOY! (.+)$/, '$1: PASS! $2'],
  [/^¡CHUCHAZO! (.+)$/, 'CHUCHAZO! $1'],
  [/^¡CAPICÚ! (.+)$/, 'CAPICÚ! $1'],
  [/^¡DOMINÓ!$/, 'DOMINO!'],
  [/^¡TRANQUE! 🔒$/, 'TRANQUE! 🔒'],
  [/^¡LA MANO GANA! ✋$/, 'THE HAND WINS! ✋'],
  [/^(.+) se pegó\. \+(\d+)(.*)$/, '$1 went out. +$2$3'],
  [/^(.+) dominó la mano$/, '$1 dominated the hand'],
  [/^El equipo de (.+) gana (\d+) puntos\.$/, "$1's team scores $2 points."],
  [/^PREMIO mano (\d+): \+(\d+)$/, 'HAND PRIZE $1: +$2'],
  [/^¡Tranque!$/, 'Tranque!'],
  [/^Empate a (\d+) puntos por equipo\.\.\.$/, 'Tied at $1 points per team...'],
  [/^¡LA MANO GANA! (.+) salió esta mano\.$/, 'THE HAND WINS! $1 led this hand.'],
  [/^Su equipo se lleva todo: \+(\d+)\.$/, 'Their team takes it all: +$1.'],
  [/^Tranque empatado: \+(\d+) para (.+)$/, 'Tied tranque: +$1 for $2'],
  [/^Mesa trancada: (\d+) vs (\d+) puntos\.$/, 'Table locked: $1 vs $2 points.'],
  [/^El equipo de (.+) se lleva \+(\d+)( \(\+25 tranque\))?\.$/, "$1's team takes +$2$3."],
  [/^Tranque: \+(\d+) para (.+)$/, 'Tranque: +$1 for $2'],
];
function netText(s) {
  if (LANG !== 'en' || typeof s !== 'string') return s;
  for (const [re, en] of NET_ES_EN) if (re.test(s)) return s.replace(re, en).replace('PREMIO mano', 'HAND PRIZE');
  return s;
}

/** Back out of a table that hasn't started (cancel matchmaking / leave a lobby). */
function leaveWaitRoom() {
  try { socket.emit('leaveRoom', () => {}); } catch (e) { /* not connected */ }
  stopMedia();
  NET.active = false; NET.code = null; NET.mySeat = null; NET.myName = '';
  restoreLobby();
}

let quickTick = null;
export function showWaitRoom(p) {
  const bg = document.getElementById('lobby-bg');
  bg.classList.add('show');
  const rows = p.seats.map((s, i) =>
    `<p>${i + 1}. ${s ? s.name + (s.isAI ? ' 🤖' : '') : L('— libre —', '— open —')}${i === p.youSeat ? ` <b>(${L('tú', 'you')})</b>` : ''}</p>`
  ).join('');
  if (quickTick) { clearInterval(quickTick); quickTick = null; }
  if (p.quick) {
    /* ⚡ matchmade table: no host, no START — the server starts it at 4 players
       or when the countdown ends (bots fill the rest). Friends can still join by code. */
    document.getElementById('lobby-modal').innerHTML = `
      <h2>⚡ ${L('BUSCANDO JUGADORES…', 'FINDING PLAYERS…')}</h2>
      <p style="opacity:.8;font-size:13px">${L('Mesa', 'Table')} <b style="color:var(--gold);letter-spacing:4px">${p.code}</b> · ${L('tus amigos pueden entrar con el código', 'friends can join with the code')}</p>
      ${rows}
      <p id="quick-count" style="margin-top:10px;font-size:22px;font-weight:900;color:var(--gold)"></p>
      <p style="opacity:.7;font-size:12px">${L('Empieza sola con 4 jugadores o al terminar la cuenta — la máquina ocupa lo que falte.', 'Starts by itself at 4 players or when the timer ends — bots fill the rest.')}</p>
      <button class="btn" id="quick-cancel" style="width:100%;margin-top:8px;background:#3a4a75">${L('Cancelar', 'Cancel')}</button>`;
    const cnt = document.getElementById('quick-count');
    const upd = () => {
      const el = document.getElementById('quick-count');
      if (!el || el !== cnt) { clearInterval(quickTick); quickTick = null; return; }
      const left = Math.max(0, Math.ceil(((p.autoStartAt || Date.now()) - Date.now()) / 1000));
      el.textContent = left > 0 ? `⏱ ${left}s` : L('¡Empezando!', 'Starting!');
    };
    upd();
    quickTick = setInterval(upd, 500);
    document.getElementById('quick-cancel').onclick = leaveWaitRoom;
    return;
  }
  document.getElementById('lobby-modal').innerHTML = `
    <h2>${L('MESA ONLINE', 'ONLINE TABLE')}</h2>
    <p>${L('Comparte el código o el enlace:', 'Share the code or the link:')}</p>
    <p style="font-size:38px;font-weight:900;color:var(--gold);letter-spacing:8px">${p.code}</p>
    <button class="btn" id="copy-invite" style="width:100%;margin:0 0 8px">🔗 ${L('Copiar enlace de invitación', 'Copy invite link')}</button>
    <div style="display:flex;gap:8px;margin:0 0 8px"><button class="btn" id="send-sms" style="flex:1">📱 ${L('Enviar por texto', 'Send by text')}</button><button class="btn" id="send-wa" style="flex:1;background:#1f7a4d">💬 WhatsApp</button></div>
    ${rows}
    <p style="opacity:.7;font-size:12px">${L('Equipos: asientos 1&amp;3 vs 2&amp;4. El que entra juega contigo (enfrente). Asientos libres los llena la máquina.',
      'Teams: seats 1&amp;3 vs 2&amp;4. Whoever joins plays with you (across). Open seats are filled by bots.')}</p>
    ${p.youSeat === p.hostSeat
      ? `<button class="btn gold" id="btn-start" style="width:100%;margin-top:10px">${L('EMPEZAR PARTIDA', 'START MATCH')}</button>`
      : `<p style="opacity:.7;margin-top:10px">${L('Esperando al anfitrión…', 'Waiting for the host…')}</p>`}
    <button class="btn" id="quick-cancel" style="width:100%;margin-top:8px;background:#3a4a75">${L('Salir de la mesa', 'Leave table')}</button>`;
  const b = document.getElementById('btn-start');
  if (b) b.onclick = () => socket.emit('startGame');
  document.getElementById('quick-cancel').onclick = leaveWaitRoom;
  const inviteLink = `${API_BASE || location.origin}/?join=${p.code}`;
  const inviteMsg = L(`¡Te invito a mi mesa de MI DOMINÓ! Código ${p.code}: ${inviteLink}`, `Join my MI DOMINÓ table! Code ${p.code}: ${inviteLink}`);
  const smsBtn = document.getElementById('send-sms');
  if (smsBtn) smsBtn.onclick = () => { location.href = 'sms:&body=' + encodeURIComponent(inviteMsg); };
  const waBtn = document.getElementById('send-wa');
  if (waBtn) waBtn.onclick = () => { window.open('https://wa.me/?text=' + encodeURIComponent(inviteMsg), '_blank'); };
  const ci = document.getElementById('copy-invite');
  if (ci) ci.onclick = () => {
    const link = `${API_BASE || location.origin}/?join=${p.code}`;
    const ok = () => { ci.textContent = L('✅ ¡Enlace copiado!', '✅ Link copied!'); banner(L('¡Enlace copiado! 🔗 Compártelo con tu socio', 'Link copied! 🔗 Share it with your partner')); setTimeout(() => { ci.textContent = '🔗 ' + L('Copiar enlace de invitación', 'Copy invite link'); }, 2500); };
    // Phones: open the system share sheet (Messages, WhatsApp, Mail...) when it exists.
    const text = L(`¡Te invito a mi mesa de MI DOMINÓ! Código ${p.code}`, `Join my MI DOMINÓ table! Code ${p.code}`);
    const nav: any = navigator;
    if (nav.share) { nav.share({ title: 'MI DOMINÓ', text, url: link }).catch(() => { /* cancelled */ }); return; }
    // No share sheet: copy it; if copying is blocked, show the link to copy by hand (no prompt() — it's blocked in the app).
    const showLink = () => {
      let box = document.getElementById('invite-link-box') as HTMLInputElement | null;
      if (!box) { box = document.createElement('input'); box.id = 'invite-link-box'; box.readOnly = true; box.style.cssText = 'width:100%;margin:0 0 8px;font-size:13px'; ci.insertAdjacentElement('afterend', box); }
      box.value = link; box.select();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(ok).catch(showLink);
    else showLink();
  };
}

export function wireSocket() {
  // Reconnection (Roadmap Phase 2.1): socket.io restores the connection; on any
  // reconnect we re-join the same table by name to reclaim our seat.
  let hadConnected = false;
  socket.on('connect', () => {
    if (hadConnected && NET.active && NET.code) {
      banner(L('Reconectando…', 'Reconnecting…'));
      socket.emit('joinRoom', { code: NET.code, name: NET.myName, token: API_TOKEN }, res => {
        if (res && !res.error) { NET.mySeat = res.seat; banner(L('¡Reconectado!', 'Reconnected!')); }
        else banner(L('No se pudo reconectar', 'Could not reconnect'));
      });
    }
    hadConnected = true;
  });
  socket.on('disconnect', () => { if (NET.active) banner(L('Conexión perdida…', 'Connection lost…')); });

  socket.on('lobby', p => { NET.active = true; NET.mySeat = p.youSeat; showWaitRoom(p); startMedia(); });
  // Perf (Phase 2.4): skip a full board re-render on an exact-duplicate state
  // (e.g. reconnect re-broadcasts / requestState) — nothing changed to draw.
  socket.on('wash', info => { stopTurnClock(); onlineWash(info); });
  socket.on('grab', () => { pendingGrab = true; }); // ¡AGARRA TUS 7! follows the reveal
  let lastStateJson = '';
  socket.on('state', s => {
    startMedia();
    endOnlineWash(); // the deal is here — end the shake
    NET.snap = s;
    hideLobby();
    // Play has started (board grew) while we were still grabbing — drop the grab.
    if (grabbingNow && s.board.length > 0) endOnlineGrab();
    // Fresh deal + a pending grab → run the tile-by-tile grab instead of just
    // dropping the hand on screen (canon: you agarra your 7 one by one).
    if (pendingGrab && s.board.length === 0 && !s.justPlayed) {
      pendingGrab = false;
      lastStateJson = JSON.stringify(s);
      renderNet();            // draw the frame (board, rivals, scores)…
      onlineGrab(s.myHand);   // …then grab your hand into the rack
      return;
    }
    const j = JSON.stringify(s);
    if (j === lastStateJson) return;
    lastStateJson = j;
    renderNet();
  });
  socket.on('logmsg', m => log(netText(m.msg), m.big));
  socket.on('banner', t => {
    banner(netText(t));
    if (t.includes('CAPICÚ')) siren();
    if (t.includes('CHUCHAZO')) explosion();
  });
  socket.on('buzzer', () => buzzer());
  socket.on('chat', c => addChat(c.name, c.msg, c.seat === NET.mySeat));
  socket.on('rematch', v => { lastRematch = v; renderRematch(v); });
  socket.on('turn', t => startTurnClock(t));
  socket.on('handEnd', p => {
    // server texts are Spanish (source of truth) — translate for EN players
    p.title = netText(p.title);
    if (Array.isArray(p.lines)) p.lines = p.lines.map(netText);
    lastRematch = null;
    stopTurnClock();
    // online hands/matches count for stats, XP, coins, streak, history (and the 🌐 mission)
    try { bookOnlineHand(p); } catch (e) { /* bookkeeping must never block the table */ }
    // ¡A CONTAR! — tally the fichas tile by tile first (canon), then the result.
    if (p.count && p.count.groups && p.count.groups.length) showNetCount(p);
    else showResult(p);
  });
  // Salir / Cerrar mesa: tabs in the top bar, visible during a game.
  const tabsNav = document.getElementById('tabs');
  const mkTab = (id: string, label: string) => {
    const b = document.createElement('button');
    b.className = 'tab';
    b.id = id;
    b.style.display = 'none';
    b.innerHTML = label;
    if (tabsNav) tabsNav.appendChild(b);
    return b;
  };
  const salirTab = mkTab('btn-salir', '🚪 <span class="tlbl">Salir</span>');
  const cerrarTab = mkTab('btn-cerrar', '🛑 <span class="tlbl">Cerrar mesa</span>');
  salirTab.onclick = () => {
    if (!confirm('¿Salir de la mesa? Un bot ocupará tu lugar.')) return;
    location.reload();
  };
  cerrarTab.onclick = () => {
    if (!confirm('¿Cerrar la mesa para todos los jugadores?')) return;
    socket.emit('closeTable', (r: any) => { if (r && r.error) banner(r.error); });
  };
  setInterval(() => {
    const on = NET.active && NET.code ? '' : 'none';
    salirTab.style.display = on;
    cerrarTab.style.display = on;
  }, 1000);
  socket.on('tableClosed', () => {
    banner(L('La mesa fue cerrada.', 'The table was closed.'));
    setTimeout(() => location.reload(), 2000);
  });
  socket.on('peers', list => { startMedia(); if (mediaOn()) return; for (const o of list) makePeer(o.socketId, o.seat, true); });
  socket.on('peerJoined', o => { startMedia(); if (mediaOn()) return; makePeer(o.socketId, o.seat, false); });
  socket.on('peerLeft', ({ socketId }) => {
    const p = NET.peers[socketId];
    if (p) { try { p.pc.close(); } catch (e) {} delete NET.peers[socketId]; }
  });
  socket.on('webrtc', async ({ from, seat, data }) => {
    const peer = NET.peers[from] || makePeer(from, seat, false);
    const pc = peer.pc;
    try {
      if (data.sdp) {
        await pc.setRemoteDescription(data.sdp);
        if (data.sdp.type === 'offer') {
          const ans = await pc.createAnswer();
          await pc.setLocalDescription(ans);
          socket.emit('webrtc', { to: from, data: { sdp: pc.localDescription } });
        }
      } else if (data.candidate) {
        await pc.addIceCandidate(data.candidate);
      }
    } catch (e) {}
  });
}
